<template>
  <v-card
    class="d-flex justify-start ma-0 my-2"
    :class="[$vuetify.breakpoint.smAndDown ? 'row mx-4' : 'pl-4']"
    flat
  >
    <v-card
      class="rectangle col-4"
      v-for="(item, i) in damage"
      :key="i"
      :class="[
        { 'ml-3': i != 0 && $vuetify.breakpoint.mdAndUp },
        { 'col-12 mb-4': $vuetify.breakpoint.smAndDown }
      ]"
    >
      <div pa-0>
        <div class="outline-menu">
          <v-img v-if="item.icon" class="menu" :src="item.icon"></v-img>
          <i
            v-else-if="item.iconfa"
            :class="`fas fa-` + item.iconfa + ` fa-3x`"
            class="ma-0 mt-2"
          ></i>
        </div>
      </div>
      <div class="stat">
        <p class="subtitle-2 mt-3 mb-2">{{ item.name }}</p>
        <p class="font-weight-medium my-0 headline number">{{ item.summary | numFormat }}</p>
        <p class="subtitle-2 my-0">{{ item.unit }}</p>
        <!-- <p class="subtitle-2 mt-3 mb-0"> สะสม </p>
        <p class="title my-0"> {{ item.summary | numFormat }} </p>-->
      </div>
    </v-card>
  </v-card>
</template>

<script>
export default {
  name: 'Today',
  data: () => ({
    damage: []
  }),
  props: {
    searchParams: {
      type: Object,
      default: {}
    }
  },
  created() {
    this.getInitDamage();
  },
  mounted() {},
  watch: {
    searchParams() {
      this.getDamage();
    }
  },
  methods: {
    getInitDamage() {
      this.damage = [
        {
          name: 'อุบัติเหตุ',
          code: 'accident',
          iconfa: 'ship',
          today: 0,
          summary: 0,
          unit: 'ครั้ง'
        },
        {
          name: 'ผู้เสียชีวิต',
          code: 'dead',
          icon: require('@/assets/icons/death.svg'),
          today: 0,
          summary: 0,
          unit: 'คน'
        },
        {
          name: 'ผู้บาดเจ็บ',
          code: 'injury',
          iconfa: 'user-injured',
          today: 0,
          summary: 0,
          unit: 'คน'
        }
      ];
    },
    getDamage() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/dashboard/summary/water`;
      // console.warn(url);
      delete this.searchParams.isBMTA;
      this.axios
        .get(url, { params: this.searchParams })
        .then(response => {
          if (response.status == 200 && response.data.data) {
            const { data } = response.data;
            const propname = ['accident', 'dead', 'injury'];
            for (let index = 0; index < propname.length; index++) {
              // const element = data[index];
              this.damage[index].today = data[propname[index]].today;
              this.damage[index].summary = data[propname[index]].summary;
            }
          }
        })
        .catch(function(error) {
          // scope.yearItems = [];
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  display: grid;
}

.col {
  padding-top: 0;
  padding-bottom: 0;
}

.col .img {
  padding: 0;
}

.card {
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  margin-top: 15px;
}

.stat {
  background-color: white;
  margin: auto;
}

.number {
  color: #ba4438;
  text-align: center;
}

p {
  text-align: center;
}

.outline-menu {
  // height: 100%;
  height: 56px;
  text-align: center;
}

.menu {
  width: 48px;
  // height: 56px;
  margin: auto;
  top: calc(50% - 24px);
}

.rectangle {
  // width: 180px;
  height: 240px;
  border-radius: 3px;
  border: solid 1px #979797;
}
</style>
